import { actionConst } from '../constants/new-wdocument.constants'
import { authHeader, authUploadHeader, authHeaderForm } from '../helpers/auth-header'
import { client } from '.';
import { requestsActions } from '../containers/Requests/requests.actions';
import { tuple } from 'antd/lib/_util/type';

export const actions = {
	openNewDocumentModal,
	closeNewDocumentModal,
	fetchDocumentTypeList,
	postDocument,
	deleteDocument,
	downloadDocument,
};

function downloadDocument(value, attachName) {
	return dispatch => {

		const rurl = '/warranty/docs/file/' + value;

		client.get(rurl, { headers: authHeader() }).then(response => {
			let data = Buffer.from(response.data, "base64");
			const url = window.URL.createObjectURL(new Blob([data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', attachName);
			document.body.appendChild(link);
			link.click();

			/* dispatch({
				type: attachmentsConstants.FETCH_ATTACHMENT,
				payload: client.get(rurl, { headers: authHeader() }),
				attachName: attachName
			})*/
		})
	}
}

function deleteDocument(doc) {
	return dispatch => {

		let rurl = '/warranty/docs/' + doc.id;

		client.delete(rurl, { headers: authHeader() })
			.then(function (response) {
				console.log(response);

				dispatch({
					type: actionConst.DELETE_DOCUMENT,
					payload: doc.requestId
				})
			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: 'requestsConstants.POST_ERROR',
					payload: error
				})
			});
	}
}

function postDocument(value, attachments, requestId) {
	return dispatch => {

		let rurl = '/warranty/docs/' + requestId;

		const formData = new FormData();
		formData.append('file', value.file);
		formData.append('direction', value.direction);
		formData.append('docDate', value.docDate);
		formData.append('name', value.name);
		formData.append('orgId', value.orgId);
		formData.append('typeId', value.typeId);

		//const v = {...value, file: attachments[0]}

		client.post(rurl, formData, { headers: authHeaderForm() })
			.then(function (response) {
				console.log(response);

				dispatch({
					type: actionConst.POST_DOCUMENT,
					payload: requestId
				})

				//dispatch(requestsActions.fetchRequests(nr));
			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: 'requestsConstants.POST_ERROR',
					payload: error
				})
			});
	}
}

function fetchDocumentTypeList() {

	let rurl = '/warranty/doc_types';

	return dispatch => {
		dispatch({
			type: actionConst.FETCH_DOCTYPE_REF,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function openNewDocumentModal(request, orgId) {
	return dispatch => {
		if (orgId) {
			dispatch({
				type: actionConst.OPEN_NEW_DOCUMENT_MODAL,
				payload: request,
				contractorId: orgId
			})
		} else {
			const rurl =  '/warranty/info/' + request;
			client.get(rurl, { headers: authHeader() }).then(res=>{
				dispatch({
					type: actionConst.OPEN_NEW_DOCUMENT_MODAL,
					payload: request,
					contractorId: res.data.orgId || null
				})		
			})
		}
	}
}

function closeNewDocumentModal() {
	return dispatch => {
		dispatch({
			type: actionConst.CLOSE_NEW_DOCUMENT_MODAL
		})
	}
}